import { cn } from '@cocoonspace/ui/lib/utils'

export const SpaceDetailsSidebarSkeleton = ({
	className,
}: {
	className?: string
}) => (
	<div
		aria-hidden
		className={cn(
			'flex flex-col md:sticky md:top-[calc(var(--app-navbar-height)+60px)] md:gap-y-4',
			className,
		)}
	>
		<div className='min-h-[260px] animate-pulse rounded-lg bg-white shadow-xs max-md:rounded-b-none' />
	</div>
)
